import { useContext } from "react"
import { GetApp } from "../../App"
import { PrintShipViewContext, ShipDataType } from "../../App/Context"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintListBlock } from "../../Components/PrintListBlock"
import { IUnitDefault } from "../../Types"
import { predefined, PrintShipViewData } from "./Context"
import { PrintShipGeneratorsViewProps } from "./Params"

// Generators. Detail-level section, only rendered when at least one is present.
export function PrintShipGeneratorsView({ data }: PrintShipGeneratorsViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { shipData } = PrintShipViewData.resolveShipData(data);

  const context = useContext(PrintShipViewContext);
  const includeShipDataType = context?.includeShipDataType || ShipDataType.short;
  const visible = !!(includeShipDataType === ShipDataType.details && shipData?.generators && shipData.generators.length > 0);

  return (
    <PrintListBlock title={t("generators")} visible={visible}>
      {shipData?.generators && shipData.generators.length > 0 && shipData.generators.map((generator, index) => (
        <div key={generator.id || index}>
          <BlockRow className="block-row-followed-by-block-row">
            <BlockField label={t("generator")} className="block-field-150">{PrintShipViewData.predefinedText(t, predefined.generatorType, generator.generatorType, "generator_")}</BlockField>
            <BlockField label={t("manufacturer")} className="block-field-210">{generator.manufacturer}</BlockField>
            <BlockField label={t("model")} className="block-field-150">{generator.model}</BlockField>
            <BlockField label={t("serial_number")} className="block-field-150">{generator.serialNumber}</BlockField>
            <BlockField label={t("power")} className="block-field-90">{generator.power} {generator.powerUnit || (generator.power ? IUnitDefault.power : "")}</BlockField>
          </BlockRow>

          <BlockRow className="block-row-last">
            <BlockField label={t("fuel_type")} className="block-field-150">{generator.fuelType ? (predefined.fuelType.includes(generator.fuelType) ? t(`fuel_${generator.fuelType}`) : generator.fuelType) : generator.fuelType}</BlockField>
            <BlockField label={t("comment")}>{generator.comment}</BlockField>
          </BlockRow>
        </div>
      ))}
    </PrintListBlock>
  );
}
